export const SAND_BOXES = [
  {
    id: 'start-widget',
    name: 'Start Rating Widget',
    url: 'https://r5lndg.csb.app/',
  },
  {
    id: 'rest-clone-vanilla',
    name: 'Restaurants Clone Vanilla',
    url: 'https://qe8xni.csb.app/',
  },
  {
    id: 'rest-clone-react',
    name: 'Restaurants Clone React',
    url: 'https://twn00c.csb.app/',
  },
  {
    id: 'search-bar',
    name: 'Search Bar / Suggestions',
    url: 'https://9gqsyy.csb.app/',
  },
  {
    id: 'render-filesystem',
    name: 'Render File System',
    url: 'https://nsi8t7.csb.app/',
  },
  {
    id: 'linked-pymk',
    name: "LinkedIn's People You May Know",
    url: 'https://xpym5c.csb.app/',
  },
  {
    id: 'img-tooltip',
    name: 'Image Tooltip',
    url: 'https://j4kdxj.csb.app/',
  },
];
